"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var LIST_OPEN_CLASS = 'kaitoriBonusLp-PartnerStores_Letter-open';
var OPEN_BUTTON_ELEMENT = "\n  <i class=\"fa fa-chevron-down kaitoriBonusLp-PartnerStores_ToggleButtonIcon\"/>\n  \u3082\u3063\u3068\u898B\u308B\n";
var CLOSE_BUTTON_ELEMENT = "\n  <i class=\"fa fa-chevron-up kaitoriBonusLp-PartnerStores_ToggleButtonIcon\"/>\n  \u5C11\u306A\u304F\u8868\u793A\n";
var AccordionController = /** @class */ (function (_super) {
    __extends(AccordionController, _super);
    function AccordionController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = function () {
            if (!_this.listTarget || !_this.toggleButtonTarget) {
                return;
            }
            var listElement = (0, jquery_1.default)(_this.listTarget);
            var toggleButtonTarget = (0, jquery_1.default)(_this.toggleButtonTarget);
            if (listElement.hasClass(LIST_OPEN_CLASS)) {
                listElement.removeClass(LIST_OPEN_CLASS);
                toggleButtonTarget.html(OPEN_BUTTON_ELEMENT);
            }
            else {
                listElement.addClass(LIST_OPEN_CLASS);
                toggleButtonTarget.html(CLOSE_BUTTON_ELEMENT);
            }
        };
        return _this;
    }
    AccordionController.targets = ['list', 'toggleButton'];
    return AccordionController;
}(stimulus_1.Controller));
exports.default = AccordionController;
